import React, { useRef, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';

/* Eliminar DENTRO de la Papelera expurga el correo del servidor: no queda copia
   de la que volver. Por eso no hay "Deshacer" y se pide confirmación con el
   número exacto. Lo usan la lista (botón, deslizar y selección) y el lector.

   `pendiente` = { cantidad, aPapelera?, ejecutar: async () => {} } o null. */
export default function ConfirmarBorradoDefinitivo({ pendiente, onCerrar }) {
  const [busy, setBusy] = useState(false);
  const cancelarRef = useRef(null);
  const n = pendiente?.cantidad || 0;
  const aPapelera = pendiente?.aPapelera || 0;

  const confirmar = async () => {
    setBusy(true);
    try {
      await pendiente.ejecutar();
    } catch {
      // Quien llama ya avisa del error; aquí solo importa cerrar.
    } finally {
      setBusy(false);
      onCerrar();
    }
  };

  return (
    <Dialog open={!!pendiente} onOpenChange={(o) => { if (!o && !busy) onCerrar(); }}>
      <DialogContent
        className="sm:max-w-[420px]"
        data-testid="borrado-definitivo"
        // Enter no debe borrar: el foco arranca en Cancelar.
        onOpenAutoFocus={(e) => { e.preventDefault(); cancelarRef.current?.focus(); }}
      >
        <DialogHeader>
          <DialogTitle>
            {n === 1 ? '¿Eliminar este correo para siempre?' : `¿Eliminar ${n} correos para siempre?`}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-2 text-sm" style={{ color: 'var(--text-2)' }}>
          <DialogDescription style={{ color: 'var(--text-2)' }}>
            {n === 1 ? 'Se borra' : 'Se borran'} del servidor de correo y{' '}
            <strong>no se {n === 1 ? 'puede' : 'pueden'} recuperar</strong>, ni desde aquí
            ni desde el móvil u otro programa.
          </DialogDescription>
          {aPapelera > 0 && (
            <p style={{ color: 'var(--text-3)' }}>
              {aPapelera === 1
                ? 'El otro correo seleccionado no está en la Papelera: ese solo se mueve a la Papelera.'
                : `Los otros ${aPapelera} seleccionados no están en la Papelera: esos solo se mueven a la Papelera.`}
            </p>
          )}
        </div>
        <DialogFooter>
          <Button ref={cancelarRef} variant="outline" onClick={onCerrar} disabled={busy}>Cancelar</Button>
          <Button
            onClick={confirmar}
            disabled={busy}
            style={{ background: 'var(--danger)', color: '#fff' }}
            data-testid="borrado-definitivo-confirmar"
          >
            {busy ? 'Eliminando…' : 'Eliminar para siempre'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

/* Texto del aviso tras eliminar: dice qué fue definitivo y qué no. */
export function avisoEliminados(definitivos, aPapelera = 0) {
  const partes = [];
  if (definitivos) partes.push(definitivos === 1 ? 'Eliminado para siempre' : `${definitivos} eliminados para siempre`);
  if (aPapelera) partes.push(`${aPapelera} movido${aPapelera === 1 ? '' : 's'} a la papelera`);
  return partes.join(' · ');
}
